// V7.9 - Service Worker Registration
// Registers the SW for offline caching without altering existing functionality

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    console.log('[SW] Service Workers not supported');
    return;
  }

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });
      console.log('[SW] Registered with scope:', registration.scope);

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('[SW] New version activated');
            }
          });
        }
      });
    } catch (error) {
      console.warn('[SW] Registration failed (non-blocking):', error);
    }
  });

  // Listen for sync messages from SW
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'SYNC_OFFLINE_EVENTS') {
      window.dispatchEvent(new CustomEvent('ella:sync-events'));
    }
    if (event.data?.type === 'SYNC_OFFLINE_IMAGES') {
      window.dispatchEvent(new CustomEvent('ella:sync-images'));
    }
  });
}
